import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CustomerRoutingModule } from './customer.routing';
import { CustomerComponent } from './customer.component';
import { CustomerDashboardComponent } from './customer-dashboard/customer-dashboard.component';

import { OverlayModule } from '@angular/cdk/overlay';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';

import { SharedModule } from 'src/app/common/modules/shared/shared.module';
import { CustomerRentComponent } from './customer-rent/customer-rent.component';
import { CustomerBuyComponent } from './customer-buy/customer-buy.component';
import { CustomerBuyFavoritesComponent } from './customer-buy-favorites/customer-buy-favorites.component';
import { CustomerRentFavoritesComponent } from './customer-rent-favorites/customer-rent-favorites.component';
import { MatSidenavModule } from '@angular/material/sidenav';
import { CustomerKeepComponent } from './customer-keep/customer-keep.component';
import { CustomerKeepFavoritesComponent } from './customer-keep-favorites/customer-keep-favorites.component';
import { DealerMenuComponent } from '../common/dealer-menu/dealer-menu.component';
import { CarCardListComponent } from 'src/app/public/car/elements/car-card-list/car-card-list.component';
import { CarCardBuyerComponent } from 'src/app/public/car/elements/car-card-buyer/car-card-buyer.component';


@NgModule({
  declarations: [
    CustomerComponent,
    
    CustomerBuyComponent,
    CustomerBuyFavoritesComponent,
    
    CustomerRentComponent,
    CustomerRentFavoritesComponent,

    CustomerKeepComponent,
    CustomerKeepFavoritesComponent,
    
    CustomerDashboardComponent
  ],
  
  imports: [
    CommonModule,
    CustomerRoutingModule,

    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatRadioModule,
    MatSelectModule,
    MatDialogModule,
    MatButtonModule,
    
    MatCardModule,
    MatGridListModule,
    MatProgressSpinnerModule,
    MatIconModule,
    MatExpansionModule,
    MatListModule,
    MatSidenavModule,
    
    OverlayModule,

    CarCardListComponent,
    CarCardBuyerComponent,

    DealerMenuComponent
    
  ]
})
export class CustomerModule { }
